/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-status-optima': {
    width: 8,
    height: 9,
    viewBox: '0 0 8 9',
    data: '<path pid="0" d="M.873 8.36c0-1.686.807-2.907 1.7-3.5-.893-.592-1.7-1.814-1.7-3.5H.436a.144.144 0 0 1-.147-.145V.923C.29.841.354.778.436.778h6.708c.081 0 .145.063.145.145v.292a.144.144 0 0 1-.145.145h-.438c0 1.686-.807 2.908-1.7 3.5.893.593 1.7 1.814 1.7 3.5h.438c.081 0 .145.065.145.146v.292a.145.145 0 0 1-.145.146H.436a.145.145 0 0 1-.147-.146v-.292c0-.081.065-.146.147-.146h.437zm.583-7c0 1.636.903 2.844 1.81 3.209h1.048c.906-.365 1.809-1.573 1.809-3.209H1.456z" fill-rule="evenodd"/>'
  }
})
